import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

// Phase 3.1 Tier 4 — Connect-button on a marketplace listing detail.
//
// Click navigates to /integrations/:slug/connect (full page, no Turbo).
// We intercept the click to fire a quick "Integration Connect Started"
// telemetry event and to disable the button while the redirect to the
// third-party authorize URL is in flight — otherwise impatient users
// double-click and we end up with stale OAuth state rows.
export default class extends Controller {
  start(event) {
    const link = event.currentTarget
    const props = this._readProps(link)
    track("Integration Connect Started", props)

    // Disable the link visually so a second click is a no-op while
    // the browser navigation kicks in.
    link.classList.add("opacity-60", "cursor-wait", "pointer-events-none")
    link.setAttribute("aria-disabled", "true")
    // Don't preventDefault — we want the browser to follow the link.
    // The button is restored by the back-cache when the user returns.
  }

  _readProps(link) {
    try {
      const raw = link.dataset.analyticsPropsValue
      return raw ? JSON.parse(raw) : {}
    } catch (_) {
      return {}
    }
  }
}
